"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dom_1 = require("../../../helpers/dom");
var literals_1 = __importDefault(require("../../../literals"));
var LanguageContext_1 = __importDefault(require("../../Provider/LanguageContext"));
var MenuItem_1 = __importDefault(require("../MenuItem"));
var styles_1 = __importDefault(require("./styles"));
var LanguageItem = function (_a) {
    var isHidden = _a.isHidden, className = _a.className, style = _a.style, isExpanded = _a.isExpanded, languages = _a.languages, languageLabel = _a.languageLabel, onLanguageClick = _a.onLanguageClick;
    if (isHidden)
        return null;
    var _b = react_1.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var language = react_1.useContext(LanguageContext_1.default);
    var languageRef = react_1.useRef();
    var handleLanguageClick = function (lang) {
        if (onLanguageClick)
            onLanguageClick(lang.locale);
        setIsOpen(false);
    };
    var options = languages.map(function (x, i) { return (react_1.default.createElement("li", { onClick: handleLanguageClick.bind(undefined, x), className: "option", key: i }, x.label)); });
    var handleClick = function () {
        setIsOpen(!isOpen);
    };
    var handleDocumentClick = function (event) {
        if (isOpen && !dom_1.isChildNode(languageRef.current, event.target))
            setIsOpen(false);
    };
    react_1.useEffect(function () {
        document.addEventListener('click', handleDocumentClick);
        return function () {
            document.removeEventListener('click', handleDocumentClick);
        };
    });
    return (react_1.default.createElement(styles_1.default, { className: className || '', style: style, ref: languageRef },
        react_1.default.createElement(MenuItem_1.default, { style: { flex: 1 }, isExpanded: isExpanded, label: languageLabel ? languageLabel : literals_1.default[language].language, onClick: handleClick, icon: "language" }),
        isOpen && react_1.default.createElement("ul", { className: "options" }, options)));
};
exports.default = LanguageItem;
//# sourceMappingURL=index.js.map